import { render } from "./search-bar.vue?vue&type=template&id=7b0a99cd&lang=pug"
import script from "./search-bar.vue?vue&type=script&lang=js"
export * from "./search-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__